import React, { useCallback } from 'react';

import { selectMessages, selectOption } from '@/features';
import { useAppDispatch, useAppSelector, useParametricSelector } from '@/store';

import { TextOption } from './FieldOptions/TextOption';

export const MessageOptions: React.FC<{
  messageId: string;
  options: string[];
}> = ({ messageId, options }) => {
  const dispatch = useAppDispatch();
  const selectedOption = useParametricSelector(
    selectMessages.makeSelectedOptionSelector,
    messageId,
  );

  const disabled =
    useAppSelector(selectMessages.newestVisitorOptionsFieldsMessageId) !==
      messageId || Boolean(selectedOption);

  const handleOptionClick = useCallback(
    (option: string) => {
      dispatch(
        selectOption({
          answerTo: messageId,
          option,
        }),
      );
    },
    [dispatch, messageId],
  );

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
      {options.map((option) => (
        <TextOption
          text={option}
          onClick={handleOptionClick}
          selected={option === selectedOption}
          disabled={disabled}
        />
      ))}
    </div>
  );
};
